import React from 'react';

export const changeEnter = (text: any) =>
  text?.split('')?.map((data: any) => (data === '\n' ? <br /> : data));

export const changeEnterHTML = (text: any) =>
  text
    ?.replace(/\{\{\$/g, '{{\\$')
    ?.split('')
    ?.map((data: any) => (data === '\n' ? '<br />' : data))
    .join('');
